var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-footnotes",class:[{ 'owc-footnotes--dark': _vm.isDarkMode }]},_vm._l((_vm.footnotes),function(footnote,index){return _c('div',{key:index,staticClass:"owc-footnotes__footnote",domProps:{"innerHTML":_vm._s(_vm.generateFootnote(index + 1, footnote))}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }